<template>
    <div class="d-flex flex-column cal-back rounded">
        <div class="header text-center month rounded">{{ month }}</div>
        <div class="m-auto day">{{ day }}</div>
        <div class="text-center year">{{ year }}</div>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "CalendarBoxView",
    mixins: [],
    props: {
        eventTime: {},
    },
    data() {
        return {
            year: "",
            day: "",
            month: "",
        };
    },
    mounted() {
        this.updateInfo(this.eventTime);
    },
    methods: {
        updateInfo(calendarData) {
            let date = new Date(calendarData);
            this.year = date.getFullYear();
            this.day = date.getDate();
            this.month = date.toLocaleString("en-US", { month: "short" });
        },
    },
    watch: {
        eventTime(newVal) {
            this.updateInfo(newVal);
        },
    },
});
</script>

<style scoped>
.cal-back {
    /* border-radius: 20px; */
    background-color: var(--bg-secondary);
    height: 110px;
    width: 110px;
    min-height: 110px;
    min-width: 110px;
}

.header {
    width: 100%;
    /* border-radius: 20px; */
    background-color: var(--dateit-primary);
}

.month {
    font-weight: bold;
    color: #fff;
    padding-top: 3px;
    padding-bottom: 3px;
}
.day {
    font-size: 26pt;
    font-weight: 500;
}
.year {
    font-size: 14pt;
    margin-top: -7px;
}

@media (max-width: 380px) {
    .cal-back {
        height: 80px;
        width: 80px;
        min-height: 80px;
        min-width: 80px;
    }

    .month {
        font-size: 8pt;
    }
    .day {
        font-size: 22pt;
    }
    .year {
        font-size: 10pt;
    }
}
</style>
